<template>
  <button
    type="submit"
    :disabled="isDisabled"
    class="checkout-submit-button"
    :class="{ 'checkout-submit-button--loading': isLoading }"
    :data-test-id="dataTestId"
  >
    <span v-if="isLoading" class="checkout-submit-button__loading">
      <span class="checkout-submit-button__spinner"></span>
      <slot name="loading">
        {{ loadingText }}
      </slot>
    </span>
    <span v-else>
      <slot></slot>
    </span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  isLoading?: boolean
  isDisabled?: boolean
  loadingText?: string
  dataTestId?: string
}

withDefaults(defineProps<Props>(), {
  isLoading: false,
  isDisabled: false,
  loadingText: '...',
  dataTestId: 'submit',
})
</script>

<style lang="postcss" scoped>
.checkout-submit-button {
  @apply w-full rounded-lg bg-teal-900 px-4 py-3 h-[46px] text-sm font-medium text-white 
    hover:bg-primary-active focus:outline-none focus:ring-2 focus:ring-primary 
    focus:ring-offset-2 disabled:opacity-50 hover:disabled:bg-teal-900 disabled:cursor-not-allowed
    transition-colors duration-200;

  &--loading {
    @apply cursor-wait;
  }

  &__loading {
    @apply flex items-center justify-center gap-2;
  }

  &__spinner {
    @apply w-4 h-4 border-2 border-white rounded-full;
    border-right-color: transparent;
    animation: spin 0.8s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
